<div class="xux-theme"> <!-- TODO: remove this container after implement xux-theme-->

  <div class="xux-calendar">

    <div class="panel panel-default" [class.no-sidebar]="menuItems.length < 2">
      <div class="panel-heading has-dropdown">
        <div class="xux-dropdown" dropdown placement="right">
          <button
            dropdownToggle
            type="button"
            class="btn xux-btn btn-default"
            aria-haspopup="true"
            aria-expanded="false"
          >
            {{activeMenuItem?.name}}
            <span class="caret"><i class="glyphicon glyphicon-menu-down"></i></span>
          </button>

          <ul class="dropdown-menu" *dropdownMenu>
            <div class="view-area no-padding">
              <div>
                <a class="xux-action-button full-width selected"
                   [ngClass]="{'selected': activeMenuItem?.id === item.id}"
                   *ngFor="let item of menuItems"
                   (click)="selectMenuItem(item)">
                  {{item.name}}
                </a>
              </div>
              <div role="separator full-width" class="divider no-margin"></div>
            </div>
          </ul>

        </div>
      </div>

      <div class="panel-heading" *ngIf="activeMenuItem?.type === 'single'">
        <div class="xux-calendar-date">
          <span>{{staticTextContent.date}}</span>
          {{formatDate(value?.dateStart, config.dateFormat.long_date_format)}}
        </div>
      </div>

      <div class="panel-body">

        <div class="xux-calendar-wrap">

          <div class="xux-calendar-sidebar" data-testid="datepicker-sidebar" *ngIf="menuItems.length > 1">

            <ng-template ngFor let-item [ngForOf]="menuItems">
              <button
                [attr.data-testid]="'datepicker-sidebar-' + item.id"
                *ngIf="!item.hidden"
                class="btn xux-btn btn-default"
                [ngClass]="{'btn-default': activeMenuItem?.id !== item.id, 'btn-primary': activeMenuItem?.id === item.id}"
                (click)="selectMenuItem(item)">
                  {{item.name}}
              </button>
            </ng-template>
          </div>

          <div class="xux-calendar-content">

            <div class="xux-tabs">
              <xux-datepicker-periods
                *ngIf="activeMenuItem?.type === 'periods'"
                [calendarValue]="defaultValue"
                [config]="config"
                [periods]="periods"
                (onChange)="setValue($event)">
              </xux-datepicker-periods>

              <xux-datepicker-periods-week
                      *ngIf="activeMenuItem?.type === 'periodsWeek'"
                      [calendarValue]="defaultValue"
                      [config]="config"
                      [weekPeriods]="weekPeriods"
                      (onChange)="setValue($event)">
              </xux-datepicker-periods-week>

              <xux-datepicker-range
                *ngIf="activeMenuItem?.type === 'range'"
                [i18n]="staticTextContent.xuxDatepickerRange"
                [calendarValue]="calendarValue"
                [config]="config"
                (onAnyChange)="onAnyCalendarChange($event)"
                (onChange)="onCalendarChange($event)"
              ></xux-datepicker-range>

              <xux-datepicker-single
                *ngIf="activeMenuItem?.type === 'single'"
                [calendarValue]="calendarValue"
                [config]="config"
                (onChange)="setValue($event)">
              </xux-datepicker-single>

              <div class="xux-tabs-footer">
                <button class="btn xux-btn btn-default" (click)="cancel()">{{staticTextContent.cancel}}</button>
                <button
                  data-testid="datepicker-apply-btn"
                  class="btn xux-btn btn-primary"
                  [class.disabled]="!canApply()"
                  [disabled]="!canApply()"
                  (click)="apply()">
                  {{staticTextContent.apply}}
                </button>
              </div>

            </div>

          </div>

        </div>

      </div>
    </div>

  </div>

</div>
